<script>
  import { _ } from 'svelte-i18n'
  import CardMainContent from '/components/Widgets/CardMainContent'
  import Related from '/components/Groups/Related'
  import Body from '/Groups/Body'
  import Details from '/Groups/Details'
  import Image from '/Atoms/Image'

  export let data

  const artwork = data?.artwork || {}

  const body = artwork.body || []
  const details = artwork.details || ""
  const image = artwork.artworkImages?.[0] || null

  const authorGroups = artwork?.relatedPeople?.filter(p => p/*.relationshipType === "author"*/) || []
  const authors = []
  for (let group of authorGroups) {
    if (group.members && group.members.length > 0) authors.push(...group.members)
  }

  const title = authors ? authors.map(p => p.title).join(", ") : artwork.title

  const parentProject = artwork?.relatedProjects?.[0]
  const category = parentProject ? parentProject.title : $_("category.exhibition")
  const category_link = parentProject ? { slug:parentProject.slug, section: "projects"} : null

</script>

<div class="container">

  <section class="main">
    <CardMainContent
      category={category}
      category_link={category_link}
      title={ title }
    >
      {#if details}
        <Details {details} />
      {/if}

      {#if image}
        <div class="image">
          <Image 
            src={image.url} 
            srcset={`${image.url} 1x, ${image.url2x} 2x`}
            caption={image.title} 
            credits={image.credits}
          />
        </div>
      {/if}

      <Body {body} />
      
    </CardMainContent>

    <Related data={artwork} />

  </section>

  <aside class="side">
    <!--SideGroup /-->
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }

  .image {
    padding-bottom: 1em;
  }

  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  li, a {
    @include typo-grotesk-text-24;
  }

</style>